<template>
 <div class="srso"> 
	<!-- <form action="/">
		<van-image
		  width="100%"
		  height="100%"
		  src="https://t3.lenovoimage.com/Upload/WebImg/WEB50_20180803203009.jpg" 
		  rel="external nofollow"  
		/> 	 
	</form> -->
	<div class="item">
		<!-- <form action="/">
		  <van-search
		    v-model="searchvalue"
		    placeholder="请输入搜索关键词"
			left-icon="search"
			:show-action = 'true'
		    @blur="onSearch"
		    @cancel="onCancel"
		  />
		</form>	 -->
		
		
		<!-- 居中 -->
		<!-- <span class="item">
		
		<van-tag mark type="primary" class="tip" @click="getData('微信打印')">微信打印</van-tag>
		<van-tag mark type="default" class="tip" @click="getData('安卓')">安卓</van-tag>		
		<van-tag mark type="danger" class="tip" @click="getData('无线连接')">无线连接</van-tag>
		<van-tag mark type="danger" class="tip" @click="getData('配网')">配网</van-tag>
		<van-tag mark type="warning" class="tip" @click="getData('卡纸')">卡纸</van-tag>
		<van-tag mark type="success" class="tip" @click="getData('清洁')">清洁</van-tag>		
		<van-tag mark type="success" class="tip" @click="getData('重置墨粉')">重置墨粉</van-tag>
		<van-tag mark type="default" class="tip" @click="getData('M100')">M100</van-tag>
		<van-tag mark type="default" class="tip" @click="getData('7268')">7268</van-tag>		
		<van-tag mark type="default" class="tip" @click="getData('领像')">领像</van-tag>
		<van-tag mark type="default" class="tip" @click="getData('小新')">小新</van-tag>
		</span> -->
		
		<!-- <van-list class="item">			
		  <van-cell v-for="item in questionlist" :key="item.id" :title="item.id + '. ' + item.title" is-link :url="item.contenturl" 
		  />	
		</van-list>		 -->
	</div>	
 </div>
</template>

<script>
// @ is an alias to /src
import Vue from 'vue'
import 'vant/lib/icon/local.css';

export default {
  name: 'DRIVERS',
  components: {	 
  },
  data(){
  		return{		
			questionlist:[],
			searchvalue:""
  		}
  	 
  },
  created(){
  	// this.getData("领像")
	// this.$root.myTitle ='问题问答';
	window.location.href ='https://abch5.lenovoimage.com/pages/helps/index.html' ;
  },
	methods:{		
		onSearch(){
					   var that  = this
					  console.log("my value:", that.searchvalue)			 
					  that.getData(that.searchvalue)
		},
		onCancel(){
					  var that  = this
					  this.searchvalue = "";
					   that.getData(that.searchvalue)
		},
		getData(keyword){
					  var that = this
					  Vue.axios.get('https://t3.lenovoimage.com/api/Web/getuserquestions?keyword=' + keyword)
					   .then(function (response) {
					    that.questionlist = response.data.Data;
					   })
					   .catch(function (error) {
					    console.log(error);
					   }) 	
					}
		,
		onClickLeft(){
			this.$router.push({ path:'/'  })
		}
	}
}
</script>
<style>
  .asp {
    margin-top: 0px;
  } 
  .item {
  	text-align: left;
  	margin-top:1px;
  }
  .tip{
	  margin:10px
  }
  /*div通用样式*/
	.toy{
		right: calc(5%);
		bottom: calc(10%);
	background: #4285F4;
	color:#ffffff;
	overflow: hidden;
	z-index: 9999;
	position: fixed;
	text-align:center;
	border-radius: 30px;
	padding:5px;
	box-shadow: 1px 1px 1px #A0A0A0;
	}
	.icon{
		  max-width: 40px;
	}
</style>




